import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

import './error-page.scss';

const ErrorPage = () => {
  const { t } = useTranslation();

  const handleNavigate = () => {
    window.location.href = '/';
  };

  return (
    <div className="error-page">
      <Result
        status="error"
        title={t('errorPage.title')}
        subTitle={t('errorPage.subtitle')}
        extra={[
          <Button key="home-btn" type="primary" onClick={handleNavigate}>
            {t('errorPage.backHome')}
          </Button>,
        ]}
      ></Result>
    </div>
  );
};
export default ErrorPage;
